import React from 'react';
import './style.scss';
import {Grid} from '@material-ui/core'
import CardMedia from '@material-ui/core/CardMedia';
import {Card, } from '@material-ui/core';
import {service, CropsGrains, FruitsVegetables, LivestockDairy, FisheriesAquaculture, AgriServicesInputs} from '../../assets/images/images'
import {makeStyles} from '@material-ui/core/styles';
import { APP_DOMAIN_PREFIX } from '../../environment';

const categoryFallbackImages = {
  'Crops & Grains': CropsGrains,
  'Fruits & Vegetables': FruitsVegetables,
  'Livestock & Dairy': LivestockDairy,
  'Fisheries & Aquaculture': FisheriesAquaculture,
  'Agri Services & Inputs': AgriServicesInputs,
};


const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    // paddingTop: theme.spacing(8),
    // paddingBottom: theme.spacing(8),
  },
  card: {
    // height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: 20,
    cursor:'pointer'
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 0,
    padding: 0,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
}));

function CategoryCard(props) {
  const {onClick,data} = props;
  const classes = useStyles();
  const displayLabel = data.agriSectorDescription === 'Agri Services & Inputs' ? 'Agri Services' : data.agriSectorDescription;
  return (
    <>
      <Grid item key={'card'} xs={12} sm={6} md={2} onClick={onClick} >
        <Card className={classes.card}>
          <h1 className='text-capitalize sub-heading-color mt-0'>{displayLabel}</h1>
          {/*<Typography gutterBottom variant="h5" component="h2">*/}
          {/*  Heading*/}
          {/*</Typography>*/}
          {!data.sectorImage ?  <CardMedia
            className={classes.cardMedia}
            // image="https://source.unsplash.com/random"
            image={categoryFallbackImages[data.agriSectorDescription] || service}
            title="Image title"
          /> : <CardMedia
              className={classes.cardMedia}
              // image="https://source.unsplash.com/random"

              image={data.sectorImage.startsWith('http') ? data.sectorImage : APP_DOMAIN_PREFIX + data.sectorImage}//Fishery}
              title="Image title"
          />}
          {/*<CardContent className={classes.cardContent}>*/}
            <h5 className='heading-color mt-10 mb-10 text-normal'>Explore More</h5>
          {/*</CardContent>*/}
        </Card>
      </Grid>
      {/*<Grid item md={3} lg={3} className='category-card-container' >*/}
      {/*  <h1 className='text-capitalize sub-heading-color'>category type</h1>*/}
      {/*  <CardMedia*/}
      {/*    className={classes.cardMedia}*/}
      {/*    image={Fishery}*/}
      {/*    title="Image title"*/}
      {/*  />*/}
      {/*  /!*<img src={Fishery} alt='img' className='category-img'/>*!/*/}
      {/*  <h3 className='heading-color'>explore more</h3>*/}
      {/*</Grid>*/}
    </>
  );
}

export default CategoryCard;
